import { useHistoryUserLocation } from "store/features/user/selectors/useHistoryUserLocation";
import { NavigationHistory, NavigationHistoryPath } from "../types";
import { UserLocation } from "entities/users";
import { useMemo } from "react";
import dayjs from "dayjs";

function getPath(userLocation: UserLocation[]): NavigationHistoryPath[] {
  let currentIndex = 0;
  let nextIndex = 1;

  return userLocation.reduce((acc, item, index, array) => {
    const currentPoint = array[currentIndex];
    const nextPoint = array[nextIndex];
    if (!nextPoint) {
      return acc;
    }

    acc.push({
      locations: [
        {
          latitude: currentPoint.latitude,
          longitude: currentPoint.longitude,
          timestampUtc: currentPoint.storeTimestampUtc,
        },
        {
          latitude: nextPoint.latitude,
          longitude: nextPoint.longitude,
          timestampUtc: nextPoint.storeTimestampUtc,
        },
      ],
      type: "Tracked",
    });

    currentIndex += 1;
    nextIndex += 1;
    return acc;
  }, [] as NavigationHistoryPath[]);
}

export const useHistoryLocations = (): NavigationHistory | undefined => {
  const historyUserLocation = useHistoryUserLocation();
  const historyUserLocationSortedByDate = [...(historyUserLocation || [])].sort(
    (a, b) => {
      const aDate = dayjs(a.storeTimestampUtc);
      const bDate = dayjs(b.storeTimestampUtc);

      return aDate.isAfter(bDate) ? 1 : -1;
    }
  );
  const startPoint = historyUserLocationSortedByDate[0];
  const endPoint =
    historyUserLocationSortedByDate[historyUserLocationSortedByDate.length - 1];

  return useMemo(
    () => {
      if (historyUserLocationSortedByDate.length > 0) {
        return {
          startLocation: {
            latitude: startPoint?.latitude ?? 0,
            longitude: startPoint?.longitude ?? 0,
            timestampUtc: startPoint?.storeTimestampUtc ?? "",
          },
          endLocation: {
            latitude: endPoint?.latitude ?? 0,
            longitude: endPoint?.longitude ?? 0,
            timestampUtc: endPoint?.storeTimestampUtc ?? "",
          },
          path: getPath(historyUserLocationSortedByDate),
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      endPoint?.latitude,
      endPoint?.longitude,
      endPoint?.storeTimestampUtc,
      historyUserLocation,
      startPoint?.latitude,
      startPoint?.longitude,
      startPoint?.storeTimestampUtc,
    ]
  );
};
